import cx from 'classnames';
import { useEffect, useState } from 'react';
import { Form, FormControl } from 'react-bootstrap';
import { useController } from 'react-hook-form';
import ReactSelect from 'react-select';
import { AsyncPaginate, withAsyncPaginate } from 'react-select-async-paginate';
import CreatableSelect from 'react-select/creatable';
import styles from './SelectController.module.scss';
const CreatableAsyncPaginate = withAsyncPaginate(CreatableSelect);


export const SelectController = ({ control, name, isMulti, label, selectStyles, creatable, containerClassName, onCreateOption, isLoading, loadOptions, ...rest }) => {
  // TODO: handle multiple values, currently only single value is supported
  const [loading, setLoading] = useState(false);
  const {
    field: { onChange, onBlur, value, ref },
    fieldState: { invalid, isTouched, isDirty, error },
    formState: { touchedFields, dirtyFields }, // TODO: work on it
  } = useController({
    name,
    control,
    // rules: { required: true },
    defaultValue: '',
  });
  const selectValue = isMulti ? value : rest.options.find((o) => o.value === value);
  let obj = {name, isMulti, label, selectStyles, creatable, containerClassName, onCreateOption, isLoading, loadOptions,selectValue, ...rest};
  const handleChange = (value) => {
    onChange(isMulti ? value : value.value);
  };

  const hasError = Boolean(error?.message);

  let Select = creatable ? CreatableSelect : ReactSelect;
  if(loadOptions) {
    Select = creatable ? CreatableAsyncPaginate : AsyncPaginate;
  }

  const handleCreateOption = async (...args) => {
    setLoading(true)
    const newOption = await onCreateOption(...args,true)
    if (newOption) {
      const data = isMulti ? [...value, newOption] : newOption.value
      onChange(data);
    }
    setLoading(false)
  }

  // console.log('loading', loading)
  return (
    <Form.Group className={containerClassName}>
      {label && <Form.Label>{label}</Form.Label>}
      <Select
        {...rest}
        value={selectValue}
        name={name}
        onChange={handleChange}
        onBlur={onBlur}
        loadOptions={loadOptions}
        {...(loadOptions ? { selectRef: ref } : { ref })}
        isMulti={isMulti}
        styles={selectStyles}
        onCreateOption={handleCreateOption}
        createOptionPosition="first"
        isLoading={loading || isLoading}
        cacheUniqs={[selectValue, loadOptions]}
        debounceTimeout={300}
      />
      <FormControl.Feedback
        type={hasError ? 'invalid' : 'valid'}
        style={{
          display: hasError ? 'block' : 'none', // TODO: work on it, for some reason bootstrap doesn't show invalid feedback
        }}>
        {error?.message}
      </FormControl.Feedback>
    </Form.Group>
  );
};